import { Injectable } from '@angular/core';
import { PortalModule } from '../../type-definitions/home/responses/home';

@Injectable({
  providedIn: 'root',
})
export class PortalModulesService {
  modules: PortalModule[] = null;

  public setPortalModules(value: PortalModule[]): PortalModule[] {
    this.modules = value;
    return this.modules;
  }

  public getPortalModules(): PortalModule[] {
    return this.modules;
  }
}
